import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Euro, Award, ArrowRight } from 'lucide-react';

const DepartmentTemplate = ({ department, departmentNumber, cities, region }) => {
  return (
    <div className="min-h-screen bg-white">
      {/* Hero Local */}
      <section className="bg-gradient-to-br from-[#2D9A68] to-[#2F5BA0] text-white py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <div className="inline-block bg-[#E6A835] px-6 py-2 rounded-full font-bold mb-6">
              📍 {region} • Département {departmentNumber}
            </div>
            <h1 className="text-4xl md:text-5xl font-bold mb-6">
              Installation Pompe à Chaleur<br/>
              dans le {department}
            </h1>
            <p className="text-xl md:text-2xl mb-8">
              Artisans RGE QualiPAC • Jusqu'à <strong className="text-[#E6A835]">15 990€ d'aides</strong><br/>
              Intervention : {cities}
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link
                to="/test-eligibilite"
                className="bg-[#E6A835] text-white px-10 py-5 rounded-xl font-bold text-lg hover:bg-[#d49520] transition-all inline-flex items-center justify-center gap-2"
              >
                <Euro className="w-6 h-6" />
                Calculer mes aides
              </Link>
              <a
                href="tel:0188617508"
                className="bg-white text-[#2D9A68] px-10 py-5 rounded-xl font-bold text-lg hover:bg-gray-100 transition-all inline-flex items-center justify-center gap-2"
              >
                <Phone className="w-6 h-6" />
                01 88 61 75 08
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Pourquoi choisir Climatpac dans ce département */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-5xl mx-auto">
            <h2 className="text-3xl font-bold text-center mb-12">
              Pourquoi choisir Climatpac 81 dans le {department} ?
            </h2>
            <div className="grid md:grid-cols-2 gap-8">
              <div className="flex items-start gap-4">
                <Award className="w-8 h-8 text-[#2D9A68] flex-shrink-0" />
                <div>
                  <h3 className="font-bold text-xl mb-2">Artisans RGE locaux</h3>
                  <p className="text-gray-600">
                    Réseau d'installateurs certifiés QualiPAC intervenant rapidement dans tout le département {departmentNumber}.
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <Euro className="w-8 h-8 text-[#2D9A68] flex-shrink-0" />
                <div>
                  <h3 className="font-bold text-xl mb-2">Aides maximisées</h3>
                  <p className="text-gray-600">
                    Nous gérons vos dossiers MaPrimeRénov' et CEE pour obtenir jusqu'à 15 990€ d'aides dans le {department}.
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <MapPin className="w-8 h-8 text-[#2D9A68] flex-shrink-0" />
                <div>
                  <h3 className="font-bold text-xl mb-2">Connaissance du terrain</h3>
                  <p className="text-gray-600">
                    Nos équipes connaissent parfaitement le climat et les spécificités des logements du {department}.
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <Phone className="w-8 h-8 text-[#2D9A68] flex-shrink-0" />
                <div>
                  <h3 className="font-bold text-xl mb-2">SAV de proximité</h3>
                  <p className="text-gray-600">
                    Service après-vente réactif avec intervention rapide sur {cities} et alentours.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Villes couvertes */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-3xl font-bold mb-6">
              Villes couvertes dans le {department}
            </h2>
            <p className="text-xl text-gray-600 mb-8">
              Installation de pompes à chaleur dans toutes les communes : {cities} et leurs agglomérations.
            </p>
            <div className="bg-blue-50 border-l-4 border-blue-500 p-6 rounded-lg text-left">
              <p className="text-blue-900">
                <strong>Votre commune n'est pas listée ?</strong> Nous intervenons dans tout le département {departmentNumber}. 
                Contactez-nous au <a href="tel:0188617508" className="font-bold underline">01 88 61 75 08</a> pour confirmer.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-16 bg-gradient-to-r from-[#2D9A68] to-[#2F5BA0] text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Projet de PAC dans le {department} ?
          </h2>
          <p className="text-xl mb-8">
            Devis gratuit et sans engagement en 24h
          </p>
          <Link
            to="/test-eligibilite"
            className="inline-flex items-center gap-2 bg-[#E6A835] text-white px-10 py-5 rounded-xl font-bold text-lg hover:bg-[#d49520] transition-all"
          >
            Je teste mon éligibilité
            <ArrowRight className="w-6 h-6" />
          </Link>
        </div>
      </section>
    </div>
  );
};

export default DepartmentTemplate;
